const CourseDetails = () => {
  return (
    <>
      <h1>Course Details</h1>
      <select>
        <option value="">Select a course</option>
        <option value="react">React</option>
        <option value="vue">Vue</option>
        <option value="angular">Angular</option>
      </select>
      <input
        style={{ marginTop: ".5rem" }}
        type="email"
        placeholder="Enter batch"
      />
    </>
  );
};

export default CourseDetails;
